import React,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import slugify from 'slugify';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@carbon/react';
import cx from 'classnames';
import {
  tabsContainer,
  list,
  listItem,
} from './PageTabs.module.scss';
import './PageTabs.scss';
import { useLocation } from "@reach/router";

const PageTabs = ({ title, tabs, slug,children=[] }) => {
  const currentTab = slug.split('/').filter(Boolean).slice(-1)[0] || slugify(tabs[0], { lower: true });
  const location = useLocation();

  const selectedIndex = tabs.findIndex(tab =>
    slugify(tab, { lower: true, strict: true }) === currentTab
  );

  useEffect(() => {
    const isUserNavigated = sessionStorage.getItem("userNavigatedTab") === "true";
    sessionStorage.removeItem("userNavigatedTab");
      //store focus only on navigate not on refresh/reload
    if (!isUserNavigated) {
      return;
    }
   else if (location.state?.focusElementLabel) {
      const tryFocus = () => {
        let elementToFocus = [...document.querySelectorAll('[role="tab"]')]
          .find(tab => tab.textContent.trim() === location.state.focusElementLabel);
  
        if (elementToFocus) {
          elementToFocus.focus();
        } else {
          console.warn("Tab not found, retrying:", location.state.focusElementLabel);
          setTimeout(tryFocus, 50); // Retry after 50ms
        }
      };
  
      setTimeout(tryFocus, 50); // Initial attempt
    }
  }, [selectedIndex]); // Ensure it runs after tab changes
  
  //override carbon tab behaviour
  const handleKeyDown = (event, index) => {
    if (event.key === "Home") {
      event.preventDefault();
      document.querySelector('[role="tab"]:first-of-type')?.focus();
    }
    
    if (event.key === "End") {
      event.preventDefault();
      document.querySelector('[role="tab"]:last-of-type')?.focus();
    }
    
    if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
      event.preventDefault();
  
      let newIndex;
      if (event.key === "ArrowRight") {
        newIndex = (index + 1) % tabs.length;
      } else if (event.key === "ArrowLeft") {
        newIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === "Enter" || event.key === " ") {
        // Select the focused tab when Enter or Space is pressed
        handleTabChange(index);
        return;
      }
  
      if (newIndex !== undefined) {
        const newTabLabel = tabs[newIndex];
        requestAnimationFrame(() => {
          const newTab = [...document.querySelectorAll('[role="tab"]')].find(
            (tab) => tab.textContent.trim() === newTabLabel
          );
  
          if (newTab) newTab.focus();
        });
      }
    }  
  };
  
  
  const handleTabChange = (eventOrIndex) => {
    const index = typeof eventOrIndex === 'object' ? eventOrIndex.selectedIndex : eventOrIndex;
    if (index < 0 || index >= tabs.length) return;

    const tabName = tabs[index];
    if (!tabName || typeof tabName !== 'string') return;

    const newTabSlug = slugify(tabName, { lower: true, strict: true });

    if (newTabSlug) {
      const currentTabRegex = new RegExp(`${currentTab}/?(#.*)?$`);
      const href = slug.replace(currentTabRegex, newTabSlug);
      sessionStorage.setItem("userNavigatedTab", "true");
      navigate(href, { state: { focusElementLabel: tabName }, replace: true });
    }
  };

  return (
    <div >
      <Tabs selectedIndex={selectedIndex} onChange={handleTabChange} >
      <div className={cx( tabsContainer)}>
        <TabList aria-label={title} className='cds--grid'  activation='manual' >
          {tabs.map((tab, index) => (
            <Tab key={tab} id={`tab-${index}`} aria-controls={`tabpanel-${index}`} className={cx(listItem)}  tabIndex={index === selectedIndex ? 0 : -1}   onKeyDown={(e) => handleKeyDown(e, index)}>
              {tab}
            </Tab>
          ))}
          </TabList>
        </div>
        <div className='cds--grid'>
        <TabPanels>
          {tabs.map((tab, index) => (
            <TabPanel key={`panel-${index}`} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} >
              {selectedIndex === index &&
                <div className='Main-module--padded--1cdb6'>
                  {children}
                </div>
              }
            </TabPanel>
          ))}
          </TabPanels>
          </div>
      </Tabs>
    </div>
  );
};

PageTabs.propTypes = {
  title: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  slug: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node),
};

export default PageTabs;
